// src/components/EmployeeRegister.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import { Form } from 'react-bootstrap';
import logo from '../assets/logo.png';
import './EmployeeRegister.css';

const EmployeeRegister = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    email: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate('/'));

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const res = await API.post('/auth/register/employee', formData);
      setMessage(res.data.message);
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="employee-shell">
      <header className="employee-topbar">
        <div className="topbar-left">
          <button className="topbar-back" type="button" onClick={goBack} aria-label="Go back">
            <span className="material-symbols-outlined">arrow_back_ios_new</span>
          </button>
          <div className="brand">
            <img src={logo} alt="Lotus Rice Mill Pvt. Ltd." className="brand-logo" />
            <span>Lotus Rice Mill Pvt. Ltd.</span>
          </div>
        </div>
        <button className="topbar-btn" type="button" onClick={() => navigate('/')}>Login</button>
      </header>

      <main className="employee-main">
        <div className="employee-card">
          <div className="employee-header">
            <h1>📝 Employee Registration</h1>
            <p>Join the Lotus Rice Mill Pvt. Ltd. team and access internal tools.</p>
          </div>

          <div className="employee-alert">
            <div>
              <strong>Success</strong>
              <span>Registration portal is active. Please fill in your details below.</span>
            </div>
            <button type="button">Dismiss</button>
          </div>

          {message && <div className="employee-message success">{message}</div>}
          {error && <div className="employee-message error">{error}</div>}

          <Form onSubmit={handleSubmit} className="employee-form">
            <label>
              Full Name
              <input name="fullName" value={formData.fullName} onChange={handleChange} placeholder="e.g. John Doe" required />
            </label>
            <label>
              Mobile
              <input name="mobile" value={formData.mobile} onChange={handleChange} placeholder="e.g. +1 234 567 890" required />
            </label>
            <label>
              Email Address
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="name@company.com" required />
            </label>
            <label>
              Password
              <div className="password-wrap">
                <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Minimum 8 characters" required />
                <span className="material-symbols-outlined">visibility</span>
              </div>
            </label>

            <button className="primary-btn" type="submit">Register</button>
          </Form>

          <div className="employee-footer">
            Already have an account? <button type="button" onClick={() => navigate('/')}>Login here</button>
          </div>
        </div>
      </main>

      <footer className="employee-bottom">
        © 2024 Lotus Rice Mill Pvt. Ltd. All rights reserved.
      </footer>
    </div>
  );
};

export default EmployeeRegister;
